const entryRemoteControls = [
  {
    text: 'Въезд/Выезд',
    value: '1',
  },
  {
    text: 'Только въезд',
    value: '2',
  },
  {
    text: 'Только выезд',
    value: '3',
  },
];
const openingTypes = [
  {
    text: 'Открытие по звонку',
    value: 'C',
  },
  {
    text: 'Открытие по пультам',
    value: 'RC',
  },
  {
    text: 'Приложение EvoLife',
    value: 'A',
  },
  {
    text: 'Распознавание ГРЗ',
    value: 'G',
  },
];
const directionMovements = [
  {
    text: 'Предусмотрен',
    value: '1',
  },
  {
    text: 'Не предусмотрен',
    value: '2',
  },
];
const accessAreas = [
  {
    text: '1',
    value: '1',
  },
  {
    text: '2',
    value: '2',
  },
];

const typeBarriers = [
  {
    value: 'B',
    name: 'Шлагбаум',
  },
  {
    value: 'G',
    name: 'Ворота',
  },
  // {
  //   value: 'BС',
  //   name: 'Контроллер',
  // },
];

const headersDevice = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'Производитель',
    value: 'manufacturer',
  },
  {
    text: 'Модель',
    value: 'model',
  },
  {
    text: 'ip-адрес',
    value: 'ip_address',
  },
  {
    text: 'mac-адрес',
    value: 'mac_address',
  },
  {
    text: 'Серийный номер',
    value: 'serial_number',
  },
  {
    text: 'Последнее обновление',
    value: 'updated_at',
  },
  {
    text: '',
    value: 'actions',
  },
];

const headersDevicesEdit = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'IP адрес',
    value: 'ip_address',
  },
  {
    text: 'Серийный номер',
    value: 'serial_number',
  },
  {
    text: 'Модель устройства',
    value: 'model',
  },
  {
    text: 'Произвоитель устройства',
    value: 'manufacturer',
  },
];

const physicalStatus = [
  { id: 1, status: 'Установлен' },
  { id: 2, status: 'Не установлен' },
  { id: 3, status: 'Без интернет соединения' },
  { id: 4, status: 'Пусконаладка' },
];
const payers = [
  { text: 'УК' },
  { text: 'Председатель' },
  { text: 'Инициативная группа' },
  { text: 'Агент' },
];

const TYPE_BARRIER = {
  B: 'Шлагбауме',
  G: 'Воротах',
};
const ENTRY_REMOTE_CONTROLS = {
  1: 'Въезд/Выезд',
  2: 'Только въезд',
  3: 'Только выезд',
};
const OPENING_TYPES = {
  C: 'Открытие по звонку',
  RC: 'Открытие по пультам',
  A: 'Приложение EvoLife',
  G: 'Распознавание ГРЗ',
};
const DIRECTION_MOVEMENTS = {
  true: 'Предусмотрен',
  false: 'Не предусмотрен',
};
const STATUS_CONDITION = {
  on: 'Включено',
  off: 'Выключено',
};
const DISPLAY_IN_APP = {
  true: 'Отображается',
  false: 'Скрыто',
};

const rules = {
  phone: [
    v => /^\+?[0-9]{10,11}$/.test(v) || 'Введите корректный номер (10-12 цифр)',
  ],
  required: [
    v => !!v || 'Поле обязательно для заполнения',
  ],
  requiredArray: [
    v => (Array.isArray(v) && v.length > 0) || 'Выберите минимум один тип открытия',
  ],
  requiredNumber: [
    v => !!v || 'Поле обязательно для заполнения',
    v => v >= 0 || 'Введите целое число',
  ],
};

const ENUM_LABELS = {
  model_barrier: {
    N: 'Nice',
    D: 'DoorHan',
    A: 'Alutech',
    C: 'Came',
    F: 'Faac',
    RT: 'Roger Technology',
  },
  gsm_module_type: {
    P: 'PAL SPIDER I-WR',
    R: 'RADS',
    D: 'DoorHan GSM-3000',
    A: 'Alutech GSM-3000',
    N: 'NAVIgard',
    L: 'Лидер',
    U: 'RTU5024',
    G: 'G202',
    None: 'Отсутствует',
  },
  remotes: {
    P: 'PAL',
    D: 'DoorHan',
    U: 'Универсальный',
    N: 'Nice OBDE',
    A: 'Alutech AR-1500',
  },
  contract_type: {
    H: 'Договор с УК',
    I: 'Индивидуальный дог-р',
    N: 'Отсутствует',
  },
  magnetic_loop: {
    L: 'LP21',
    N: 'Нет',
  },
};

const isBarrierWithoutMonitoring = (barrier) => {
  if (!barrier) return false;
  return barrier.physical_status === 5 || !!barrier.old_device_name;
};

const isBarrierOnline = (barrier) => barrier?.sip_status === '2';

const getBarrierSipStatusColor = (barrier) => {
  if (!barrier) return 'grey';
  if (barrier.sip_status_color) return barrier.sip_status_color;
  if (isBarrierWithoutMonitoring(barrier)) return 'orange';
  if (barrier.sip_status === '2') return 'green';
  if (barrier.sip_status === null) return 'red';
  return 'grey';
};

const getBarrierSipStatusText = (barrier) => {
  if (!barrier) return '';
  if (barrier.sip_status_text) return barrier.sip_status_text;
  if (isBarrierWithoutMonitoring(barrier)) return 'Без мониторинга';
  if (barrier.sip_status === '2') return 'В сети';
  if (barrier.sip_status === null) return 'Не в сети';
  return 'Неизвестно';
};

const parseOpeningTypeValues = (item) => {
  if (Array.isArray(item)) {
    return item;
  }
  if (item === 'CG') {
    return ['C', 'G'];
  }
  return item ? String(item).split(',').map(v => v.trim()).filter(Boolean) : [];
};

const getOpeningTypeLabels = (item) => {
  return parseOpeningTypeValues(item).map(v => OPENING_TYPES[v]).filter(Boolean);
};

const formatOpeningType = (item) => {
  return getOpeningTypeLabels(item).join(', ');
};

const formatOpeningTypeCollapsed = (item) => {
  return `${getOpeningTypeLabels(item).slice(0, 2).join(', ')}…`;
};

const hasManyOpeningTypes = (item) => {
  return getOpeningTypeLabels(item).length > 2;
};

export {
  entryRemoteControls, directionMovements, rules, accessAreas, openingTypes, typeBarriers, headersDevice,
  TYPE_BARRIER, ENTRY_REMOTE_CONTROLS, OPENING_TYPES, DIRECTION_MOVEMENTS, DISPLAY_IN_APP, headersDevicesEdit,
  physicalStatus, payers, STATUS_CONDITION, ENUM_LABELS,
  isBarrierWithoutMonitoring, isBarrierOnline, getBarrierSipStatusColor, getBarrierSipStatusText,
  parseOpeningTypeValues, getOpeningTypeLabels, formatOpeningType, formatOpeningTypeCollapsed, hasManyOpeningTypes,
};
